import type { ProviderAccount } from '@/api/schemas';
import { ConfirmArchiveDialog } from '@/components/ConfirmArchiveDialog';
import { ProviderAccountSheet } from './ProviderAccountSheet';
import { ReplaceTokenDialog } from './ReplaceTokenDialog';
import type { AccountDialogs } from './useAccountDialogs';

interface Props {
  dialogs: AccountDialogs;
  /** The disable request is running. */
  busy: boolean;
  onDisable: (account: ProviderAccount) => void;
}

const IMPACT = [{ text: 'Running builds finish on it.' }, { text: 'Nothing new is dispatched to it: profiles that use it cannot build until it is enabled again.' }];

/** The connect/edit sheet, the replace-token dialog and the disable confirmation of the provider accounts. */
export function ProviderAccountOverlays({ dialogs, busy, onDisable }: Props) {
  const { sheet, replacing, disabling } = dialogs;
  return (
    <>
      <ProviderAccountSheet open={Boolean(sheet)} onOpenChange={(o) => (o ? undefined : dialogs.setSheet(null))} editing={sheet?.editing} kind={sheet?.kind} />
      <ReplaceTokenDialog account={replacing} onOpenChange={(o) => (o ? undefined : dialogs.setReplacing(null))} />
      <ConfirmArchiveDialog
        open={Boolean(disabling)}
        onOpenChange={(o) => (o ? undefined : dialogs.setDisabling(null))}
        testId="provider-account-disable-dialog"
        title={`Disable ${disabling?.name ?? 'the account'}?`}
        description="It stays registered and can be enabled again. What changes:"
        impact={IMPACT}
        confirmLabel="Disable"
        busy={busy}
        onConfirm={() => (disabling ? onDisable(disabling) : undefined)}
      />
    </>
  );
}
